import React from 'react';
import { inject, observer } from 'mobx-react';
import { List, SimpleListItem } from '@rmwc/list';
import { SimpleMenuSurface } from '@rmwc/menu';

import MenuIcon from '../../assets/bars.inline.svg';
import UserIcon from '../../assets/user.inline.svg';

@inject('headerState')
@observer
class ActionMenus extends React.PureComponent {
  handleDrawerOpen = () => {
    this.props.headerState.openDrawer();
  };

  render() {
    const { memberSignedIn } = this.props.headerState;

    let styleNames = 'mvc-action-menus without-members-menu';
    if (memberSignedIn) {
      styleNames = 'mvc-action-menus';
    }

    return (
      <div className={styleNames}>
        <MenuIcon onClick={this.handleDrawerOpen} className="mvc-menu-icon" />
        {memberSignedIn && (
          <SimpleMenuSurface handle={<UserIcon className="vector-icon" />}>
            <List>
              <SimpleListItem tag="a" href="/members/profile" text="Profile" />
              <SimpleListItem
                tag="a"
                href="/members/edit_password"
                text="Password"
              />
              <SimpleListItem tag="a" href="/members/grades" text="My Votes" />
              <SimpleListItem
                tag="a"
                data-method="delete"
                href="/members/sign_out?ui_version=mvc_awards"
                text="Log Out"
              />
            </List>
          </SimpleMenuSurface>
        )}
      </div>
    );
  }
}

export default ActionMenus;
